<template>
  <base-warning v-model="modelValue">
    <div class="d-flex flex-column gap-1">
      <p>
        A dose deve ser prescrita de acordo com o peso do paciente e o nível sérico de IgE medido antes do início do
        tratamento. As doses estão nas Tabelas 1 e 2 abaixo. <br />
        Para saber quantas seringas de 75 mg e 150 mg aplicar, veja a Tabela 3.
      </p>

      <figure>
        <img src="/assets/attendance-form/medicine-prescription/omalizumab/table-1.png" alt="" />
        <figcaption>Tabela 1 - Dose de Omalizumabe administrada por injeção subcutânea a cada 4 semanas.</figcaption>
      </figure>

      <figure>
        <img src="/assets/attendance-form/medicine-prescription/omalizumab/table-2.png" alt="" />
        <figcaption>Tabela 2 - Dose de Omalizumabe administrada por injeção subcutânea a cada 2 semanas.</figcaption>
      </figure>

      <figure>
        <img src="/assets/attendance-form/medicine-prescription/omalizumab/table-3.png" alt="" />
        <figcaption>
          Tabela 3 - Conversão de dose para número de seringas preenchidas, número de injeções e volume total de injeção
          para cada administração.
        </figcaption>
      </figure>

      <p>
        Para solicitar esse medicamento via <span class="font-weight-bold">OPERADORA DE SAÚDE</span>, atente-se para às
        seguintes exigências:
      </p>

      <div v-html="asthmaRequirements['asma-alergica-grave']" />
    </div>
  </base-warning>
</template>

<script>
import { ComputedOptions } from 'vue'
import BaseWarning from '../BaseWarning.vue'
import asthmaRequirements from './helper/commonRequirements'

export default {
  components: { BaseWarning },
  name: 'ConductWarning.Omalizumabe75',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asthmaRequirements,
    }
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
